<template>
  <div>
    <div class="form__field">
      <div
        v-for="option in options"
        :key="option.value"
        class="form__field__item"
      >
        <label
          class="checkbox"
          :class="{ 'is--checked': localValue.includes(option.value) }"
        >
          <input
            v-model="localValue"
            class="checkbox__input"
            type="checkbox"
            :value="option.value"
          />
          <span class="checkbox__marker" />
          {{ option.label }}
        </label>
      </div>
    </div>
    <ErrorMessage v-if="validator" v-show="validator.$error">
      <span v-if="validator.$model === undefined"
        >Je hebt bovenstaande vraag nog niet beantwoord.</span
      >
      <span v-else>{{ errorMessage }}</span>
    </ErrorMessage>
  </div>
</template>

<script>
import ErrorMessage from "../ErrorMessage";

export default {
  name: "CheckboxGroup",
  components: {
    ErrorMessage
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    errorMessage: {
      type: String,
      default: "We missen nog je antwoord op deze vraag."
    },
    validator: {
      type: Object,
      required: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);

        if (this.validator) {
          this.validator.$touch();
        }

        this.scrollToNextQuestion();
      }
    },
    classes() {
      return {
        "is--checked": this.localValue === true
      };
    }
  }
};
</script>

<style scoped lang="scss">
.checkbox {
  display: block;
  width: 100%;
  padding: 20px 30px;
  background-color: $color-purple;
  color: white;
  border-radius: 5px;
  box-shadow: 0 5px 5px #00000029;
  cursor: pointer;
  transition: background-color $transition-speed;

  &.is--checked {
    background-color: $color-green;
  }

  &__input {
    position: absolute;
    visibility: hidden;
    width: 0;
    height: 0;
    pointer-events: none;
  }

  &__input:checked + &__marker::after {
    opacity: 1;
  }

  &__marker {
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 20px;
    height: 20px;
    margin-right: 20px;
    border: 2px solid white;
    border-radius: 3px;

    &::after {
      content: "";
      position: absolute;
      top: 3px;
      left: 3px;
      width: 10px;
      height: 10px;
      background-color: white;
      opacity: 0;
      transition: opacity $transition-speed;
    }
  }
}
</style>
